import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhTextComponent } from './components/fh-text.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FhTextComponent],
  exports: [FhTextComponent]
})
export class FhTextModule {}
